import React from "react";
import styled from "styled-components";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Avatar } from "@sonder/ui/source/styled/components/Avatar";
import { colors } from "@sonder/ui/source/styled/theme";

interface InfoCardProps {
  avatarName?: string;
  avatarUrl?: string;
  onClick?(): void;
  subtext: string;
  text: string;
}

const StyledChevronRightIcon = styled(ChevronRightIcon)`
  margin-left: 0.5rem;
  visibility: hidden;
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 1.714rem 0.964rem 1.714rem 1.714rem;

  &:hover {
    background-color: ${colors.grayF};
    cursor: pointer;

    ${StyledChevronRightIcon} {
      visibility: visible;
    }
  }
`;

const Content = styled.div`
  flex: 1;
  line-height: 1.429rem;
`;

const Subtext = styled.div`
  font-size: 0.857rem;
  line-height: 1.143rem;
  margin-top: 0.357rem;
`;

const StyledAvatar = styled(Avatar)`
  margin-right: 1rem;
  zoom: 1.33;
`;

const Text = styled.div`
  font-weight: bold;
`;

export const InfoCard = ({
  avatarName,
  avatarUrl,
  onClick,
  subtext,
  text,
}: InfoCardProps) => (
  <Container onClick={onClick}>
    {(avatarName || avatarUrl) && (
      <StyledAvatar imageUrl={avatarUrl} name={avatarName} />
    )}
    <Content>
      <Text>{text}</Text>
      {subtext && <Subtext>{subtext}</Subtext>}
    </Content>
    {onClick && <StyledChevronRightIcon />}
  </Container>
);
